<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.customerContactTypes.contactTypes') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('settings.backToSettings') }}
        </d-button>
        <d-button theme="success" @click.prevent="$router.push('/ustawienia/typy-kontaktow-z-klientem/nowy')">
          <i class="material-icons">add</i>
          {{ $t('settings.customerContactTypes.addNewCustomerContactType') }}
        </d-button>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0" style="width: 40px;">{{ $t('settings.customerContactTypes.icon') }}</th>
            <th scope="col" class="border-0">{{ $t('settings.customerContactTypes.name') }}</th>
            <th scope="col" class="border-0">{{ $t('settings.customerContactTypes.type') }}</th>
            <th scope="col" class="border-0">{{ $t('settings.customerContactTypes.isDefault') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(contactType, index) of contactTypes"
            :key="'contact-type-' + index">
            <td class="align-middle">
              <i
                v-if="contactType.type === 'EMAIL'"
                class="material-icons">email</i>
              <i
                v-else-if="contactType.type === 'PHONE'"
                class="material-icons">call</i>
              <i
                v-else-if="contactType.type === 'MEETING'"
                class="material-icons">groups</i>
              <i
                v-else-if="contactType.type === 'PATTERN_SENDING'"
                class="material-icons cursor-help"
                :title="$t('customer.contact.typePatternSending')">texture</i>
              <i
                v-else-if="contactType.type === 'SPEC_CAT_SENDING'"
                class="material-icons cursor-help"
                :title="$t('customer.contact.typeSpecCatSending')">unarchive</i>
              <img
                v-else-if="contactType.icon_url"
                :src="contactType.icon_url"
                height="24"
                width="24"
                alt="">
              <i
                v-else
                class="material-icons cursor-help"
                :title="contactType.name">help</i>
            </td>
            <td class="align-middle">
              {{ contactType.name }}
            </td>
            <td class="align-middle">
              {{ contactType.type }}
            </td>
            <td class="align-middle">
              <span
                v-if="contactType.is_default"
                class="text-success">
                {{ $t('ui.yes') }}
              </span>
              <span
                v-else
                class="text-danger">
                {{ $t('ui.no') }}
              </span>
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/ustawienia/typy-kontaktow-z-klientem/edycja/' + contactType.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                @click.native="removeContactType(contactType.id)"
                :disabled="removeInProgress || !contactType.can_delete"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="contactTypes.length === 0">
            <td
              colspan="3"
              class="text-center">
              {{ $t('settings.customerContactTypes.noContactTypesToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import ListUtils from './../utils/ListUtils.js';

export default {
  name: 'customer-contact-types',
  data() {
    return {
      contactTypes: [],
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, '/customer-contact-types/items', 'contactTypes');
    },
    removeContactType (contactTypeID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/customer-contact-types/delete/',
        id: contactTypeID,
        successTitle: this.$t('settings.customerContactTypes.removeContactTypeSuccessTitle'),
        successText: this.$t('settings.customerContactTypes.removeContactTypeSuccessText'),
        confirmTitle: this.$t('settings.customerContactTypes.removeContactTypeConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.customerContactTypes.removeContactTypeErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

